import { render, staticRenderFns } from "./FieldTypeNumber.vue?vue&type=template&id=cf4e394e&"
import script from "./FieldTypeNumber.vue?vue&type=script&lang=ts&"
export * from "./FieldTypeNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports